/**
 * Обнаруживает элементы с data-c1/data-c2 и раскрывает контакты.
 * Поддерживает:
 *  - data-type="m" → email: c1 + "@" + c2
 *  - data-type="t" → телефон: c1 + " " + c2  (href: tel: без пробелов, скобок и дефисов)
 * Если элемент <a>, то проставляется href.
 * Текст элемента устанавливается в `[data-contact-text]`, а если его нет,
 * то в сам элемент при отсутствии класса `no-text`.
 *
 * Пример разметки:
 *   <a class="contacts__mail no-text" data-c1="info" data-c2="cinemati.ge" data-type="m"></a>
 */
function revealContacts(root = document.body) {
    const nodes = root.querySelectorAll("[data-c1]");
    if (nodes.length === 0)
        return;
    nodes.forEach((el) => {
        const type = (el.getAttribute("data-type") || "").trim(); // "m" | "t"
        const c1 = el.getAttribute("data-c1") || "";
        const c2 = el.getAttribute("data-c2") || "";
        if (!type || !c1 || !c2)
            return;
        let text = "";
        switch (type) {
            case "m": {
                // email
                text = `${c1}@${c2}`;
                if (isAnchor(el))
                    el.setAttribute("href", `mailto:${text}`);
                break;
            }
            case "t": {
                // phone
                text = `${c1} ${c2}`;
                const telHref = normalizePhoneForHref(text);
                if (isAnchor(el))
                    el.setAttribute("href", `tel:${telHref}`);
                break;
            }
            default:
                return;
        }
        // Если есть placeholder для текста, заполняем только его и не трогаем иконки/вложенный HTML.
        const textTarget = el.querySelector("[data-contact-text]");
        if (textTarget) {
            textTarget.textContent = text;
        }
        else if (!el.classList.contains("no-text")) {
            // legacy fallback: заменяем текст, если нет отдельного placeholder
            el.textContent = text;
        }
    });
}
function isAnchor(el) {
    return el.tagName.toLowerCase() === "a";
}
/** Убираем пробелы, скобки, дефисы — оставляем только пригодные для tel: символы */
function normalizePhoneForHref(s) {
    // в legacy: text.replaceAll(/\(|\)|\s|\-/gi, '')
    // эквивалентно:
    return s.replace(/[()\s-]+/g, "");
}

export { revealContacts as default, revealContacts };
